import { useState } from 'react';

/**
 * The settings page's one message box. `show` replaces what it says and opens
 * it. `close` closes it and reports whether the panel asked to stay open (a
 * failed system-identification save or a failed force gas & electric save
 * keeps the form so the operator can retry); `keepOpen` left out keeps the
 * earlier answer.
 */
export const useSettingsMessage = () => {
  const [content, setContent] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [keepPanelOpen, setKeepPanelOpen] = useState(false);

  const show = (nextContent, { keepOpen } = {}) => {
    setContent(nextContent);
    if (keepOpen !== undefined) {
      setKeepPanelOpen(keepOpen);
    }
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setKeepPanelOpen(false);
    return keepPanelOpen;
  };

  return { content, isOpen, show, close };
};
